function pad(n: number): string {
  return n < 10 ? '0' + n : String(n);
}

function parse(input: string | number | Date | null | undefined): Date | null {
  if (input == null || input === '') return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTime(input: string | number | Date | null | undefined, fallback = '—'): string {
  const d = parse(input);
  if (!d) return fallback;
  return (
    d.getFullYear() +
    '-' + pad(d.getMonth() + 1) +
    '-' + pad(d.getDate()) +
    ' ' + pad(d.getHours()) +
    ':' + pad(d.getMinutes()) +
    ':' + pad(d.getSeconds())
  );
}

export function formatDate(input: string | number | Date | null | undefined, fallback = '—'): string {
  const d = parse(input);
  if (!d) return fallback;
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}

export function formatDateTimeShort(input: string | number | Date | null | undefined, fallback = '—'): string {
  const d = parse(input);
  if (!d) return fallback;
  return (
    pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
    ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
  );
}
